import type { PortalBranding } from '../hooks/usePortalConfig'
import { createContext, useContext } from 'react'
import type { ReactNode } from 'react'

export interface PortalConfig {
  branding: PortalBranding
  beaconId?: string | null
}

const PortalConfigContext = createContext<PortalConfig | null>(null)

export const PortalConfigProvider = ({
  value,
  children,
}: {
  value: PortalConfig
  children: ReactNode
}) => (
  <PortalConfigContext.Provider value={value}>
    {children}
  </PortalConfigContext.Provider>
)

const usePortalConfig = (): PortalConfig => {
  const config = useContext(PortalConfigContext)
  if (!config) {
    throw new Error(
      'usePortalConfig must be used within a PortalConfigProvider'
    )
  }
  return config
}

// The portal Beacon id, shared by the header nav and the resolved-conversation
// CTA so neither has to refetch the branding endpoint.
export const useBeaconId = (): string | null | undefined =>
  usePortalConfig().beaconId
